import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiX } from 'react-icons/hi';
import { toast } from 'sonner';
import TextInput from '../forms/TextInput';
import QuizTypeSelectInput from '../forms/QuizTypeSelectInput';
import CourseTopicSelector from '../forms/CourseTopicSelector';
import Button from '../ui/Button';
import { useQuizzes } from '../../contexts/QuizContext';

const QuizModal = ({ isOpen, onClose, currentQuiz = null, onSuccess = () => {} }) => {
	const { addQuiz, editQuiz } = useQuizzes();

	const {
		register,
		handleSubmit,
		reset,
		setValue,
		watch,
		formState: { errors, isSubmitting },
	} = useForm();

	const topicId = watch('topic_id') || currentQuiz?.topic;

	useEffect(() => {
		console.log(currentQuiz)
		if (currentQuiz) {
			reset({
				topic_id: currentQuiz.topic,
				course_id: currentQuiz.topic_detail.course,
				quiz_type: currentQuiz.quiz_type,
				expected_duration: currentQuiz.expected_duration
					? parseInt(currentQuiz.expected_duration.split(':')[1])
					: '',
				is_private: currentQuiz.is_private,
			});
		} else {
			reset({
				quiz_type: '',
				topic_id: '',
				expected_duration: '',
				is_private: false,
			});
		}
	}, [currentQuiz, reset]);

	const onSubmit = async (data) => {
		const payload = {
			quiz_type: data.quiz_type,
			topic: data.topic_id,
			expected_duration: data.expected_duration ? `${data.expected_duration}:00` : null,
			is_private: data.is_private,
		};

		try {
			let quiz;
			if (currentQuiz) {
				quiz = await editQuiz(currentQuiz.id, payload);
				toast.success('Quiz updated successfully');
			} else {
				quiz = await addQuiz(payload);
				toast.success('Quiz created successfully');
			}
			onSuccess(quiz);
			reset();
			onClose();
		} catch (error) {
			const errData = error?.response?.data;
			toast.error(errData?.detail || errData?.non_field_errors?.[0] || 'Failed to save quiz');
			console.error(error);
		}
	};

	if (!isOpen) return null;

	return (
		<div className="modal modal-open">
			<div className="modal-box max-w-xl">
				<label className="absolute right-4 top-4">
					<HiX className="h-6 w-6 cursor-pointer" onClick={onClose} />
				</label>
				<h3 className="font-semibold text-lg text-center mb-2">
					{currentQuiz ? 'Edit Quiz' : 'Create a New Quiz'}
				</h3>
				<p className="text-gray-600 text-sm text-center mb-4">
					{currentQuiz ? 'Update quiz settings below' : 'Select the topic and type of quiz to get started'}
				</p>

				<form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
					<CourseTopicSelector register={register} errors={errors} watch={watch} />

					{topicId && (
						<>
							<QuizTypeSelectInput
								name="quiz_type"
								register={register}
								errors={errors}
								helpText="Choose the type of quiz"
							/>

							<TextInput
								name="expected_duration"
								label="Duration (minutes)"
								type="number"
								placeholder="e.g. 30"
								errors={errors}
								register={register}
								min={1}
							/>

							<div>
								<label className="block font-medium text-sm mb-1">Quiz Privacy</label>
								<div className="flex items-center">
									<input
										type="checkbox"
										{...register('is_private')}
										className="checkbox"
									/>
									<span className="ml-2 text-gray-600">Private</span>
								</div>
							</div>
						</>
					)}

					<div className="modal-action">
						<Button type="button" variant="ghost" onClick={onClose}>Cancel</Button>
						<Button type="submit" isLoading={isSubmitting} disabled={!topicId}>
							{currentQuiz ? 'Update' : 'Create'} Quiz
						</Button>
					</div>
				</form>
			</div>

			<div className="modal-backdrop" onClick={onClose}>
				<button className="cursor-default">&nbsp;</button>
			</div>
		</div>
	);
};

export default QuizModal;
